module.exports = __webpack_public_path__ + "img/Icone__todas_.a50ca256.svg";